import { render, staticRenderFns } from "./AdmisionReporteAptitudComputo.vue?vue&type=template&id=23e83c62"
import script from "./AdmisionReporteAptitudComputo.vue?vue&type=script&lang=js"
export * from "./AdmisionReporteAptitudComputo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports